// === Lodash ===
window._ = require('lodash');

// === Slugify ===
window.slugify = require('slugify');

// === jQuery ===
window.$ = window.jQuery = require('jquery');

// === Datepicker ===
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');
$.fn.datepicker.dates['fr'] = {
	...$.fn.datepicker.dates['fr'], ...{
		daysMin: ["Dㅤㅤㅤi.", "Lu.", "Ma.", "Me.", "Je.", "Ve.", "Sa."],
	}
};

// === Popper ===
window.Popper = require('popper.js').default;

// === Bootstrap ===
require('bootstrap');

// === Toastr ===
window.toastr = require('toastr');

// === Owl Carousel ===
require('owl.carousel');

// === Awesomplete ===
require('awesomplete');

// === Scripts communs ===
require('../common');

// === Moment ===
window.moment = require('moment')
